module.exports = __webpack_public_path__ + "static/a call-e9a09c3935f98685e8c58cf81807e1f1.wav";